import React, { useEffect, useState } from "react";
import "../../Css/Landing.css";
import { useNavigate } from "react-router-dom";
import loaderGif from "../../assets/Grid.png";
import { basicauthblog } from "../../basicauth";
import { User } from "lucide-react";

function OurBlog() {
  const navigate = useNavigate();

  const [cards, setCards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const blogsPerPage = 8;
  const [searchTerm, setSearchTerm] = useState("");

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [visibleCards, setVisibleCards] = useState(3);

  const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);

  const AuthorImage = ({ image, name }) => {
    const [imageError, setImageError] = useState(false);

    if (!image || imageError) {
      return (
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100">
          <User size={18} strokeWidth={2} className="text-gray-500" />
        </div>
      );
    }

    return (
      <img
        src={image}
        alt={name || "Author"}
        className="h-8 w-8 rounded-full object-cover"
        onError={() => setImageError(true)}
      />
    );
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setVisibleCards(1);
      } else if (window.innerWidth < 1024) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetAllProductBlog`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ webid: "6" }),
        },
      );

      const data = await response.json();

      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => Number(b.id) - Number(a.id),
        );

        setCards(sortedData);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetBlogByHashtags = async (tagSlug) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetBlogByHashtags`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ hashtag: tagSlug, webid: "6" }),
        },
      );

      const data = await response.json();

      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => Number(b.id) - Number(a.id),
        );

        setCards(sortedData);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (sessionStorage.getItem("FromTag") === "1") {
        const tagSlug = JSON.parse(sessionStorage.getItem("tag"));
        await GetBlogByHashtags(tagSlug);
        sessionStorage.removeItem("FromTag");
      } else {
        await Getproductblogs();
      }
    };

    fetchData();
  }, []);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;

  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();

    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });

  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const loopCards =
    currentBlogs.length > 0
      ? Array.from({ length: 8 }).map(
          (_, i) => currentBlogs[i % currentBlogs.length],
        )
      : [];

  const sliderCards = [...loopCards, ...loopCards.slice(0, visibleCards)];

  useEffect(() => {
    if (loopCards.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
      setIsTransitioning(true);
    }, 2000);

    return () => clearInterval(interval);
  }, [loopCards.length]);

  useEffect(() => {
    setCurrentIndex(0);
    setIsTransitioning(true);
  }, [visibleCards]);

  return (
    <section className="mb-5 p-3" style={{ background: "#ececec" }}>
      <div
        className="bg-white p-4 sm:p-6 md:p-8"
        style={{
          margin: "1rem auto",
          borderRadius: "5%",
          maxWidth: "1400px",
        }}
      >
        <h2 className="text-left text-[#212529] text-xl md:text-[28px] font-sf font-semibold">
          Discover Our Blogs
        </h2>

        <p className="mb-3 mt-2 font-sf md:text-[18px] text-gray-500">
          Insights to power your business logistics
        </p>

        {isLoading && (
          <div className="flex items-center justify-center">
            <img src={loaderGif} alt="Loading..." />
          </div>
        )}

        <div className="w-full overflow-hidden">
          <div
            className="flex"
            style={{
              transform: `translateX(-${currentIndex * (100 / visibleCards)}%)`,
              transition: isTransitioning ? "transform 0.7s ease" : "none",
            }}
            onTransitionEnd={() => {
              if (currentIndex >= loopCards.length) {
                setIsTransitioning(false);
                setCurrentIndex(0);

                setTimeout(() => {
                  setIsTransitioning(true);
                }, 50);
              }
            }}
          >
            {sliderCards.map((item, i) => (
              <div
                key={i}
                className="flex-shrink-0 px-2"
                style={{
                  width: `${100 / visibleCards}%`,
                }}
              >
                <div
                  className="My-Landing-card relative flex min-h-[440px] flex-col border border-gray-200 pb-12"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "1rem",
                  }}
                >
                  <img
                    src={item?.image_url}
                    alt={item?.title}
                    className="h-[180px] w-full object-center sm:h-[200px] md:h-[190px] lg:h-[200px]"
                    style={{
                      borderTopRightRadius: "1rem",
                      borderTopLeftRadius: "1rem",
                    }}
                  />

                  <div className="card-content overflow-hidden px-3 pb-4">
                    <div className="mt-3 flex">
                      <div>
                        <AuthorImage
                          image={item?.author_image}
                          name={item?.author_name}
                        />
                      </div>

                      <div className="flex items-center">
                        <p className="ml-2 text-base text-gray-500">
                          {item?.author_name}
                        </p>
                      </div>
                    </div>

                    <h6 className="mt-2 text-[18px] font-semibold leading-snug">
                      {item?.title}
                    </h6>

                    <p className="mt-2 text-base leading-5 text-gray-600">
                      {item?.excerpt}
                    </p>

                    <div
                      className="absolute bottom-4 left-3 cursor-pointer text-[#2563eb] hover:underline"
                      onClick={() => {
                        sessionStorage.setItem("Slug", JSON.stringify(item));
                        navigate(`/blog/${item.slug}`);
                      }}
                    >
                      Read More
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurBlog;
